module.exports = __webpack_public_path__ + "static/img/akum_800_230.9674d26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_230.svg
// module id = 4atk
// module chunks = 1